module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(!_vm.data.length) ? _c('Loader') : _vm._e(), _vm._v(" "), _c('svg', {
    staticClass: "chart",
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('g', {
    style: ({
      transform: ("translate(" + (_vm.margin.left) + "px, " + (_vm.margin.top) + "px)")
    }),
    attrs: {
      "id": "container"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c0bed2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/GroupedBarChart.vue
// module id = 395
// module chunks = 1